import * as React from "react";
import trim from "lodash/trim";
import trunc from "lodash/truncate";
import stringify from "util/stringify";
import EmptyValue from "views/components/EmptyValue";
const FormattedValue = ({ field, value, truncate, render, type }) => {
  const stringified = stringify(value);
  const Component = render;
  return trim(stringified) === "" ? /* @__PURE__ */ React.createElement(EmptyValue, null) : /* @__PURE__ */ React.createElement(Component, { field, value: truncate ? trunc(stringified) : stringified, type });
};
export default FormattedValue;
